import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { WorkflowStep } from 'app/models/workflow-step';
import { WorkflowStepCompletion } from 'app/models/workflow-step-completion';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import _ from 'lodash';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-clone-step-completion',
  templateUrl: './clone-step-completion.component.html',
  styleUrls: ['./clone-step-completion.component.scss']
})
export class CloneStepCompletionComponent implements OnInit {

  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() cloned: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  currentStepCompletionFormGroup: FormGroup = null;

  @ViewChild('cloneModal', {static: false}) cloneModal: ModalDirective;

  constructor(private workflowTemplateService: WorkflowTemplateService, private workflowWizardService: WorkflowWizardService) { }

  ngOnInit(): void {
  }

  show(stepCompletionFormGroupToClone: FormGroup) {
    this.currentStepCompletionFormGroup = stepCompletionFormGroupToClone;

    if (!this.currentStepCompletionFormGroup?.value?.next_step?.name) {
      // simple cloning
      this.cloneDecisionOnly();
    } else {
      this.cloneModal.show();
    }
  }

  cloneDecisionOnly() {
    let clonedStepCompletion: WorkflowStepCompletion = this.cloneStepCompletionWithoutIDs(this.currentStepCompletionFormGroup.value, true);
    clonedStepCompletion.name = clonedStepCompletion.name + ' Copy';
    this.cloned.emit(this.workflowTemplateService.addNewStepCompletionToStep(this.currentStepCompletionFormGroup.parent.parent as FormGroup,
      clonedStepCompletion));
    if (this.cloneModal.isShown) {
      this.cloneModal.hide();
    }
  }

  cloneBranch() {
    let clonedStepCompletion: WorkflowStepCompletion = this.cloneStepCompletionWithoutIDs(this.currentStepCompletionFormGroup.value, false);
    clonedStepCompletion.name = clonedStepCompletion.name + ' Copy';
    this.cloned.emit(this.workflowTemplateService.addNewStepCompletionToStep(this.currentStepCompletionFormGroup.parent.parent as FormGroup,
      clonedStepCompletion));
    this.workflowWizardService.updateAllValueAndValidity();
    if (this.cloneModal.isShown) {
      this.cloneModal.hide();
    }
  }

  isStepNameUnique(stepName: string, stepCompletion: WorkflowStepCompletion = null) {
    if (!stepCompletion) {
      stepCompletion = this.workflowWizardService.workflowTemplateFormGroup.value.initial_step_completion;
    }

    if (stepCompletion.next_step) {
      if (stepCompletion.next_step.name == stepName) {
        return false;
      } else {
        let isUnique: boolean = true;
        (stepCompletion.next_step.step_completions || []).forEach((s) => {
          isUnique = isUnique && this.isStepNameUnique(stepName, s);
        });
        return isUnique;
      }
    }

    return true;
  }

  cloneStepWithoutIDs(step: WorkflowStep) {
    let clonedStep = _.cloneDeep(step);
    clonedStep.default_step_completion_id = undefined;
    let newStepName: string = clonedStep.name + ' Copy';
    let trials = 2;
    while (!this.isStepNameUnique(newStepName) && trials < 100) {
      newStepName = clonedStep.name + ' Copy ' + trials++;
    }
    clonedStep.name = newStepName;

    let clonedStepCompletions = [];
    (clonedStep.step_completions || []).forEach((s) => {
      clonedStepCompletions.push(this.cloneStepCompletionWithoutIDs(s));
    });
    clonedStep.step_completions = clonedStepCompletions;
    (clonedStep.workflow_step_external_operations || []).forEach((e) => {
      e.id = undefined;
    });
    
    return clonedStep;
  }

  cloneStepCompletionWithoutIDs(stepCompletion: WorkflowStepCompletion, deleteNextStep: boolean = false) {
    let clonedStepCompletion = _.cloneDeep(stepCompletion);
    clonedStepCompletion.id = undefined;
    if (clonedStepCompletion.next_step) {
      if(deleteNextStep) {
        clonedStepCompletion.next_step = undefined;
      } else {
        clonedStepCompletion.next_step = this.cloneStepWithoutIDs(clonedStepCompletion.next_step);
      }
    }

    (clonedStepCompletion.forms || []).forEach((f) => {
      f.id = undefined;
    });
    (clonedStepCompletion.files || []).forEach((f) => {
      f.id = undefined;
    });
    (clonedStepCompletion.files || []).forEach((f) => {
      f.id = undefined;
    });
    (clonedStepCompletion.auto_emails || []).forEach((f) => {
      f.id = undefined;
    });
    (clonedStepCompletion.auto_uploads || []).forEach((f) => {
      f.id = undefined;
    });
    (clonedStepCompletion.auto_starts || []).forEach((f) => {
      f.id = undefined;
    });

    return clonedStepCompletion;
  }
}
